// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__328_a","calendarButtons":"ClockData_calendarButtons__1Z_Ip"};